<template>
  <div id="app">
  
    <nav-menu :admin="admin" :authenticated="authenticated" @authenticated="check_auth" @passwordMenu="passwordMenu" @menuItem="menuItem" @refresh="refresh"></nav-menu>
    <Password v-if="(newUser || changePassword) && authenticated && !dynamicComponent" @passwordMenu="passwordMenu" @newUser="newChange"></Password>
    <component v-if="authenticated" :is="dynamicComponent" @menuItem="menuItem" ></component>
    <Login v-if="!authenticated" :authenticated="authenticated" @authenticated="check_auth" ></Login>
    <div v-if="!hide && !dynamicComponent && !newUser && authenticated && !changePassword">
      <performance ></performance>
      <Orders :admin="admin"></Orders>
    </div>
    
  </div>
</template>

<script>
/* eslint-disable */ 
import NavMenu from './components/navbar.vue'
import Login from './components/login.vue'
import Performance from './components/performance.vue'
import Orders from './components/orders.vue'
import Password from './components/password.vue'
import addUser from './components/adduser.vue'
import editUsers from './components/editusers.vue'
import addPerformance from './components/addperformance.vue'
import performanceEdit from './components/performanceedit.vue'
import posOrder from './components/posorder.vue'
import addStream from './components/addstream.vue'
import editStream from './components/editstream.vue'

export default {
  name: 'app',
  components: {
    NavMenu,
    Login,
    Performance,
    Orders,
    Password,
    addUser,
    editUsers,
    addPerformance,
    performanceEdit,
    posOrder,
    addStream,
    editStream
  },
  data () {
    return {
      authenticated: false,
      newUser: false,
      admin: false,
      changePassword: false,
      dynamicComponent: false,
      hide: false,
      
    }
  },
  methods: {
    check_auth(auth) {
      this.authenticated = auth.Authenticated
      this.admin = auth.Administrator
      this.newUser = auth.newUser
    },
    passwordMenu(_show) {
      this.changePassword = _show
    },
    newChange() {
      this.newUser = false;
    },
    menuItem(_item) {
      this.dynamicComponent = _item;
    },
    refresh(_state) {
      this.hide = _state;
    },

  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>
